<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2021-01-20 19:22:35
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/order/detail/index.vue
-->
<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-11-21 09:42:22
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/order/detail/index.vue
-->
<template>
  <div class="order_detail">
    <!-- titleBar -->
    <img src="@/assets/order/header_bg@2x.png" alt="" class="header_bg" />
    <div class="detail_con">
      <!-- icon_back_default_dark@2x -->
      <!-- icon_back@2x -->
      <div :style="bgStyle" class="bar_header">
        <img
          :src="opacityStyle.opacity !== 1 ? whiteGo : blackGo"
          alt=""
          class="icon_back left"
          @click="back"
        />
        <div
          :style="opacityStyle"
          class="font18 colo087 font_weight500 line_height_48"
          @click="back"
        >
          订单详情
        </div>
      </div>
      <!-- 头部信息 -->
      <div class="top_det">
        <header-det @clickBtn="clickBtn" />
      </div>
      <!-- 地址信息 -->
      <div ref="addDet" class="top_address">
        <address-det />
      </div>
      <!-- 商品信息 -->
      <div class="product_con_det">
        <shop-header @goExplain="goExplain" />
        <!-- 商品信息 -->
        <div
          v-for="(item, index1) in getUserOrder.retailSubOrderList"
          :key="index1"
          :class="{ pad_mr: index1 !== 0 }"
          class="product_pad"
        >
          <div
            v-if="getUserOrder.retailSubOrderList.length > 1"
            :class="{ bao_mr: index1 !== 0 }"
            class="font12 font_weight500 colo087 text_left bao_name"
          >
            包裹{{ index1 + 1 }}
          </div>
          <!-- 包裹物流信息 -->
          <det-log-det
            v-if="item.trackingData && item.trackingData !== null"
            :trackingData="item.trackingData[0]"
          />
          <!-- 商品信息 -->
          <div v-for="(i, index2) in item.orderDetailList" :key="index2">
            <order-product-list
              v-if="!i.isGift"
              :listIndex="index2"
              :pageShow="false"
              :item="i"
            />
            <!-- 赠品 -->
            <div v-if="i.isGift" class="free_product_list">
              <free-product :showBor="false" :freeProduct="i" />
            </div>
          </div>
          <!-- 底部按钮 -->
          <product-bottom-btn
            v-if="
              (getUserOrder.retailSubOrderList !== null &&
                getUserOrder.status !== 10 &&
                getUserOrder.status !== -10 &&
                getUserOrder.status !== -11) ||
                item.orderType === 2
            "
            @clickBtn="clickBtn"
            :btnList="
              orderBtns(
                getUserOrder.retailSubOrderList.length,
                item.orderType,
                item.status
              )
            "
            :item="item"
            :packageIndex="index1"
          />
        </div>
      </div>
      <!-- 订单信息 -->
      <div class="det_det1">
        <order-product-det />
      </div>
      <!-- 订单价格 -->
      <order-price />
      <bottom-btn
        @cancelOrder="cancelOrder"
        @applyRefund="applyRefund"
        @clickBtn="clickBtn"
        :btnList="
          orderBtn(
            getUserOrder.status,
            getUserOrder.afterType,
            getUserOrder.orderType,
            getUserOrder.retailSubOrderList.length
          )
        "
        :packageIndex="0"
      />
    </div>
    <cancel-action-sheet
      v-if="showCancel"
      @closeSheet="closeSheet"
      @confirmReasion="confirmReasion"
    />
    <!-- <pharmacist /> -->
  </div>
</template>
<script>
import HeaderDet from "./components/HeaderDet";
import AddressDet from "./components/AddressDet";
import ShopHeader from "./components/ShopHeader";
import OrderProductList from "../list/components/OrderProductList";
import FreeProduct from "./components/FreeProduct";
import OrderProductDet from "./components/OrderProductDet";
import OrderPrice from "./components/OrderPrice";
import BottomBtn from "./components/BottomBtn";
import CancelActionSheet from "./components/CancelActionSheet";
import ProductBottomBtn from "./components/ProductBottomBtn";
import DetLogDet from "./components/DetLogDet";
// import Pharmacist from "@/components/Pharmacist";
export default {
  name: "OrderDetail",
  components: {
    HeaderDet,
    AddressDet,
    ShopHeader,
    OrderProductList,
    FreeProduct,
    OrderProductDet,
    OrderPrice,
    BottomBtn,
    CancelActionSheet,
    ProductBottomBtn,
    DetLogDet
    // Pharmacist
  },
  data() {
    return {
      showCancel: false,
      bgStyle: {
        backgroundColor: "rgba(255,255,255," + 0 + ")"
      },
      opacityStyle: {
        opacity: 0
      },
      whiteGo: require("@/assets/common/icon_back_default_dark@2x.png"),
      blackGo: require("@/assets/common/icon_back@2x.png")
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  computed: {
    getUserOrder() {
      return this.$store.getters.getUserOrder;
    },
    getSpuId() {
      const { retailSubOrderList } = this.$store.getters.getUserOrder;
      let spuId = "";
      retailSubOrderList.forEach(item => {
        item.orderDetailList.forEach(i => {
          if (!i.isGift) {
            spuId = i.spuId;
            return;
          }
        });
      });
      return spuId;
    }
  },
  created() {
    this.getData();
  },
  methods: {
    //tabBar透明度
    handleScroll() {
      let top = document.documentElement.scrollTop || document.body.scrollTop;
      let detTo = this.$refs.addDet.offsetTop;
      // let detTo = 1000;
      let opacity = top / 500;
      opacity = opacity > 1 ? 1 : opacity;
      this.bgStyle = { backgroundColor: "rgba(255,255,255," + opacity + ")" };
      this.opacityStyle = { opacity };
      this.opacityName = { opacity };
      if (top < detTo) {
        this.opacityStyle = {
          opacity: opacity
        };
      } else {
        this.bgStyle = { backgroundColor: "rgba(255,255,255,1)" };
        this.opacityStyle = {
          opacity: 1
        };
      }
    },
    // getUserOrder
    // 获取数据
    getData() {
      const params = {
        orderSn: this.$route.query.orderSn
      };
      // console.log(params, "params");
      this.$store
        .dispatch("order/getUserOrder", { params })
        .then(() => {})
        .catch(() => {});
    },
    back() {
      this.$router.push({
        path: "/order/list"
      });
    },
    clickBar() {
      // console.log(232323);
    },
    // 取消接口
    cancelData(refundReason) {
      this.$store
        .dispatch("order/cancelOrder", {
          params: {
            orderSn: this.$route.query.orderSn,
            refundReason
          }
        })
        .then(() => {
          this.getData();
          this.showCancel = false;
          this.$toast("订单取消成功");
        })
        .catch(() => {});
    },
    // 删除接口
    deleteData() {
      this.$store
        .dispatch("order/deleteOrder", {
          params: {
            orderSn: this.$route.query.orderSn
          }
        })
        .then(() => {
          this.$router.back();
          this.showCancel = false;
          this.$toast("订单删除成功");
        })
        .catch(() => {});
    },
    // 再次购买接口
    againBuy() {
      this.$store
        .dispatch("order/againBuy", {
          params: {
            orderSn: this.$route.query.orderSn
          }
        })
        .then(() => {
          this.$router.push("/cart");
        })
        .catch(() => {});
    },
    // 确认收货
    confirmOrder(subOrderSn) {
      this.$store
        .dispatch("order/confirmOrder", {
          params: {
            subOrderSn
          }
        })
        .then(() => {
          this.getData();
        })
        .catch(() => {});
    },
    // 点击按钮
    clickBtn(name, orderSn, packageIndex, subOrderSn, spuId) {
      // console.log(name, orderSn, packageIndex, subOrderSn, 7777);
      switch (name) {
        case "取消订单":
          this.showCancel = true;
          break;
        case "去付款":
          // /order/orderpay?orderSn=FY20112062347625
          this.$router.push({
            path: "/order/orderpay",
            query: {
              orderSn: this.getUserOrder.orderSn
            }
          });
          break;
        case "查看物流":
          this.$router.push({
            path: "/order/detail/logistics",
            query: {
              orderSn: this.getUserOrder.orderSn,
              subOrderSn,
              packageIndex
            }
          });
          break;
        case "提醒发货":
          this.$toast("已提醒发货");
          break;
        case "申请退款":
          this.$router.push({
            path: "/order/refund/orderdetailrefundreasion",
            query: {
              orderSn: this.getUserOrder.orderSn,
              gmtCreate: this.getUserOrder.gmtCreate
            }
          });
          break;
        case "确认收货":
          this.$dialog
            .confirm({
              message: "您确定要确认收货吗？",
              confirmButtonText: "确定",
              confirmButtonColor: "#DD9132"
            })
            .then(() => {
              // 确认收货
              this.confirmOrder(subOrderSn);
            })
            .catch(() => {});
          break;
        case "再次购买":
          if (this.getUserOrder.orderType === 0) {
            this.againBuy();
          } else {
            // 跳转详情
            this.$router.push({
              path: "/product/detail",
              query: {
                id: spuId || this.getSpuId
              }
            });
          }
          break;
        case "申请售后":
          if (this.getUserOrder.orderType === 0) {
            this.$router.push({
              path: "/order/refund/applypackage",
              query: {
                orderType: this.getUserOrder.orderType,
                orderSn: this.getUserOrder.orderSn
              }
            });
          } else if (this.getUserOrder.orderType === 1) {
            // console.log(subOrderSn);
            // getPeriodOptionalAfterOrder 鲜奶可申请售后周期
            // this.$store
            //   .dispatch("order/getPeriodOptionalAfterOrder", {
            //     params: {
            //       orderSn: this.getUserOrder.orderSn
            //     }
            //   })
            //   .then(res => {
            //     console.log(res);
            // return;
            localStorage.setItem(
              "mall-wap-refund-type",
              this.getUserOrder.orderType
            );
            this.$router.push({
              path: "/order/refund/chooserefundtype",
              query: {
                orderType: this.getUserOrder.orderType,
                orderSn: this.getUserOrder.orderSn,
                subOrderSn: subOrderSn
              }
            });
            // })
            // .catch(() => {});
          }
          break;
        case "删除订单":
          this.$dialog
            .confirm({
              message: "您确定要删除该订单吗？",
              confirmButtonText: "确定",
              confirmButtonColor: "#DD9132"
            })
            .then(() => {
              this.deleteData();
            })
            .catch(() => {});
          break;
        case "配送计划":
          this.$router.push({
            path: "/order/milkplan",
            query: {
              orderSn: this.getUserOrder.orderSn,
              subOrderSn: this.getUserOrder.retailSubOrderList[0].subOrderSn
            }
          });
          break;
        case "前往使用":
          this.$router.push({
            path: "/mine/cardpackagelist"
          });
          break;
      }
    },
    // 取消订单
    cancelOrder() {
      this.showCancel = true;
    },
    // 配送计划
    milkPlan() {
      this.$router.push("/order/milkplan");
    },
    // 待发货申请退款
    applyRefund() {
      // 待发货
      // this.$router.push("/order/refund/orderdetailrefundreasion");
      // 发货后
      this.$router.push("/order/refund/applypackage");
    },
    closeSheet() {
      this.showCancel = false;
    },
    confirmReasion(refundReason) {
      this.cancelData(refundReason);
    },
    lookLogist() {
      this.$router.push("/order/detail/logistics");
    },
    orderBtn(status, afterType, orderType, orderListLength) {
      switch (status) {
        case 10:
          return [
            {
              name: "取消订单",
              isLightHeight: false
            },
            {
              name: "去付款",
              isLightHeight: true
            }
          ];
        case 11:
          switch (orderType) {
            case 0:
              switch (afterType) {
                case 1:
                  return [
                    {
                      name: "申请退款",
                      isLightHeight: false
                    }
                  ];
                default:
                  return [];
              }
            case 1:
              switch (afterType) {
                case 1:
                  return [
                    {
                      name: "申请退款",
                      isLightHeight: false
                    }
                  ];
                default:
                  return [];
              }
            default:
              switch (afterType) {
                case 2:
                  return [
                    {
                      name: "申请退款",
                      isLightHeight: false
                    }
                  ];
                default:
                  return [];
              }
          }
        case 12:
          switch (orderType) {
            case 0:
              switch (afterType) {
                case 2:
                  if (orderListLength === 1) {
                    return [
                      {
                        name: "申请售后",
                        isLightHeight: false
                      }
                      // {
                      //   name: "查看物流",
                      //   isLightHeight: false
                      // }
                    ];
                  } else {
                    return [
                      {
                        name: "申请售后",
                        isLightHeight: false
                      }
                    ];
                  }
                default:
                  // if (orderListLength === 1) {
                  //   return [
                  //     {
                  //       name: "查看物流",
                  //       isLightHeight: false
                  //     }
                  //   ];
                  // } else {
                  //   return [];
                  // }
                  return [];
              }
            case 1:
              switch (afterType) {
                case 2:
                  if (orderListLength === 1) {
                    return [
                      {
                        name: "申请售后",
                        isLightHeight: false
                      }
                      // {
                      //   name: "配送计划",
                      //   isLightHeight: false
                      // }
                    ];
                  } else {
                    return [
                      {
                        name: "申请售后",
                        isLightHeight: false
                      }
                    ];
                  }
                default:
                  // if (orderListLength === 1) {
                  //   return [
                  //     {
                  //       name: "配送计划",
                  //       isLightHeight: false
                  //     }
                  //   ];
                  // } else {
                  //   return [];
                  // }
                  return [];
              }
            default:
              switch (afterType) {
                case 2:
                  return [
                    {
                      name: "申请售后",
                      isLightHeight: false
                    }
                  ];
                default:
                  return [];
              }
          }
        case 13:
        case 14:
          switch (orderType) {
            case 0:
              switch (afterType) {
                case 2:
                  return [
                    {
                      name: "申请售后",
                      isLightHeight: false
                    },
                    {
                      name: "删除订单",
                      isLightHeight: false
                    },
                    {
                      name: "再次购买",
                      isLightHeight: true
                    }
                  ];
                default:
                  return [
                    {
                      name: "删除订单",
                      isLightHeight: false
                    },
                    {
                      name: "再次购买",
                      isLightHeight: true
                    }
                  ];
              }
            case 1:
              switch (afterType) {
                case 2:
                  if (orderListLength === 1) {
                    return [
                      {
                        name: "申请售后",
                        isLightHeight: false
                      },
                      // {
                      //   name: "配送计划",
                      //   isLightHeight: false
                      // },
                      {
                        name: "再次购买",
                        isLightHeight: false
                      }
                    ];
                  } else {
                    return [
                      {
                        name: "申请售后",
                        isLightHeight: false
                      },
                      {
                        name: "再次购买",
                        isLightHeight: false
                      }
                    ];
                  }

                default:
                  if (orderListLength === 1) {
                    return [
                      // {
                      //   name: "配送计划",
                      //   isLightHeight: false
                      // },
                      {
                        name: "再次购买",
                        isLightHeight: false
                      }
                    ];
                  } else {
                    return [
                      {
                        name: "再次购买",
                        isLightHeight: false
                      }
                    ];
                  }
              }
            case 2:
              switch (afterType) {
                case 1:
                  return [
                    {
                      name: "申请退款",
                      isLightHeight: false
                    },
                    {
                      name: "删除订单",
                      isLightHeight: false
                    },
                    {
                      name: "再次购买",
                      isLightHeight: true
                    }
                  ];
                case 2:
                  return [
                    {
                      name: "申请售后",
                      isLightHeight: false
                    },
                    {
                      name: "删除订单",
                      isLightHeight: false
                    },
                    {
                      name: "再次购买",
                      isLightHeight: true
                    }
                  ];
                default:
                  return [
                    {
                      name: "删除订单",
                      isLightHeight: false
                    },
                    {
                      name: "再次购买",
                      isLightHeight: true
                    }
                  ];
              }
          }
          break;
        case -10:
        case -11:
          return [
            {
              name: "删除订单",
              isLightHeight: false
            },
            {
              name: "再次购买",
              isLightHeight: true
            }
          ];
      }
    },
    orderBtns(orderListLength, orderType, status) {
      // orderListLength 通过包裹的长度 1是单包裹，>1是多包裹
      // orderType 0普通商品 1周期购 2虚拟卡
      // afterType 0不可取消 1可取消 2可售后
      // status 订单状态(单包裹订单维度状态，多包裹是包裹维度的状态)
      switch (status) {
        // 待付款
        case 10:
          // return [
          //   {
          //     name: "取消订单",
          //     isLightHeight: false
          //   },
          //   {
          //     name: "去付款",
          //     isLightHeight: true
          //   }
          // ];
          break;
        // 待发货
        case 11:
          // 单包裹
          if (orderListLength === 1) {
            switch (orderType) {
              // 普通商品
              case 0:
                return [
                  {
                    name: "查看物流",
                    isLightHeight: false
                  },
                  {
                    name: "提醒发货",
                    isLightHeight: true
                  }
                ];
              // 周期购
              case 1:
                return [
                  {
                    name: "配送计划",
                    isLightHeight: false
                  },
                  {
                    name: "提醒发货",
                    isLightHeight: true
                  }
                ];
            }
            // 多包裹
          } else {
            switch (orderType) {
              // 普通商品
              case 0:
                return [
                  {
                    name: "查看物流",
                    isLightHeight: false
                  },
                  {
                    name: "提醒发货",
                    isLightHeight: true
                  }
                ];
              // 周期购
              case 1:
                return [
                  {
                    name: "配送计划",
                    isLightHeight: false
                  },
                  {
                    name: "提醒发货",
                    isLightHeight: true
                  }
                ];
            }
          }
          break;
        // 待收货
        case 12:
          // 单包裹
          if (orderListLength === 1) {
            switch (orderType) {
              // 普通商品
              case 0:
                return [
                  {
                    name: "查看物流",
                    isLightHeight: false
                  },
                  {
                    name: "确认收货",
                    isLightHeight: true
                  }
                ];
              // 周期购
              case 1:
                return [
                  {
                    name: "配送计划",
                    isLightHeight: false
                  }
                  // {
                  //   name: "确认收货",
                  //   isLightHeight: true
                  // }
                ];
            }
            // 多包裹
          } else {
            switch (orderType) {
              // 普通商品
              case 0:
                return [
                  {
                    name: "查看物流",
                    isLightHeight: false
                  },
                  {
                    name: "确认收货",
                    isLightHeight: true
                  }
                ];
              // 周期购
              case 1:
                return [
                  {
                    name: "配送计划",
                    isLightHeight: false
                  }
                  // {
                  //   name: "确认收货",
                  //   isLightHeight: true
                  // }
                ];
            }
          }
          break;
        // 已完成
        case 13:
        case 14:
          if (orderListLength === 1) {
            switch (orderType) {
              // 普通商品
              case 0:
                return [
                  {
                    name: "查看物流",
                    isLightHeight: false
                  },
                  {
                    name: "再次购买",
                    isLightHeight: true
                  }
                ];
              // 周期购
              case 1:
                return [
                  {
                    name: "配送计划",
                    isLightHeight: false
                  },
                  {
                    name: "再次购买",
                    isLightHeight: true
                  }
                ];
              // 虚拟卡
              case 2:
                return [
                  {
                    name: "前往使用",
                    isLightHeight: true
                  }
                ];
            }
            // 多包裹
          } else {
            switch (orderType) {
              // 普通商品
              case 0:
                return [
                  {
                    name: "查看物流",
                    isLightHeight: false
                  },
                  {
                    name: "再次购买",
                    isLightHeight: true
                  }
                ];
              // 周期购
              case 1:
                return [
                  {
                    name: "配送计划",
                    isLightHeight: false
                  },
                  {
                    name: "再次购买",
                    isLightHeight: true
                  }
                ];
              // 虚拟卡
              case 2:
                return [
                  {
                    name: "前往使用",
                    isLightHeight: true
                  }
                ];
            }
          }
          break;
        // 已关闭
        case -10:
        case -11:
          return [
            {
              name: "再次购买",
              isLightHeight: false
            }
          ];
      }
    },
    // 发货说明
    goExplain() {
      if (this.getUserOrder.orderType === 1) {
        this.$router.push("/order/milkexplaintime");
      } else {
        this.$router.push("/order/explaintime");
      }
    }
  }
};
</script>
<style lang="less" scoped>
.order_detail {
  position: relative;
  z-index: 1;
  .detail_con {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 99;
    .bar_header {
      position: fixed;
      top: 0;
      right: 0;
      left: 0;
      padding-right: 36px;
      z-index: 99;
      .icon_back {
        width: 24px;
        margin: 12px 0 0 12px;
        z-index: 100;
      }
    }
  }

  .header_bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    z-index: 0;
  }
  .top_det {
    margin-top: 25px;
  }
  .top_address {
    margin-top: 20px;
  }
  .product_con_det {
    // margin-top: 12px;
    // background: #fff;
    // box-shadow: 0px 10px 10px -6px #f2f0f0;
    //  box-shadow:inset 0px 15px 10px -15px #000;
    // box-shadow: inset 0px 15px 10px -15px #f00;
    background: #fff;
    border-radius: 8px;
    .product_pad {
      padding-bottom: 9px;
      background: #fff;
    }
    .pad_mr {
      // margin-top: 10px;
      // border-top: 4px solid #f6f7f8;
    }
  }
  .free_product_list {
    background: #fff;
    margin: 0 12px;
  }
  //
  .bao_name {
    padding: 4px 12px;
  }
}
</style>
